import { createSlice } from '@reduxjs/toolkit';

export const DEFAULT_PROMO_FILTERS = {
  dateFrom: '',
  dateTo: '',
  promotionType: '',
  status: '',
};

const promoSlice = createSlice({
  name: 'promo',
  initialState: {
    checkedItems: [],
    activeTab: 'Informacje',
    currentPage: 1,
    maxPages: 1,
    totalCount: 0,
    sortBy: null,
    sortDirection: null,
    keyword: null,
    searchValue: '',
    filters: DEFAULT_PROMO_FILTERS,
  },
  reducers: {
    toggleActiveTab: (state, action) => {
      state.activeTab = action.payload;
    },
    setCheckedItems: (state, action) => {
      state.checkedItems = action.payload;
    },
    toggleCheckedItem: (state, action) => {
      const id = action.payload;
      if (state.checkedItems.includes(id)) {
        state.checkedItems = state.checkedItems.filter((item) => item !== id);
      } else {
        state.checkedItems.push(id);
      }
    },
    setSorting(state, action) {
      state.checkedItems = [];
      const { sortBy, sortDirection } = action.payload;
      state.sortBy = sortBy;
      state.sortDirection = sortDirection;
      state.currentPage = 1;
    },
    setPage(state, action) {
      state.currentPage = action.payload;
    },
    setMaxPages(state, action) {
      state.maxPages = action.payload;
    },
    setTotalCount(state, action) {
      state.totalCount = action.payload;
    },
    setKeyword: (state, action) => {
      state.keyword = action.payload;
      state.currentPage = 1;
    },
    setSearchValue: (state, action) => {
      state.searchValue = action.payload;
    },
    setFilters: (state, action) => {
      state.filters = action.payload;
      state.currentPage = 1;
      state.checkedItems = [];
    },
    clearFilters: (state) => {
      state.filters = { ...DEFAULT_PROMO_FILTERS };
      state.currentPage = 1;
      state.checkedItems = [];
    },
  },
});

export const {
  setCheckedItems,
  toggleCheckedItem,
  setPage,
  setMaxPages,
  setTotalCount,
  setSorting,
  setKeyword,
  setSearchValue,
  toggleActiveTab,
  setFilters,
  clearFilters,
} = promoSlice.actions;

export default promoSlice.reducer;
